import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

const slides = [
  {
    id: 1,
    title: "每日大瓜",
    subtitle: "首发曝光",
    tagline: "全网追踪",
    description: "顶流网红人设崩塌，前女友实锤爆料引全网震动",
    link: "/article/dingji-wanghong-renshe-bengta",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20moody%20dramatic%20scene%20of%20paparazzi%20and%20celebrity%20scandal%20atmosphere%20with%20camera%20flashes%20in%20darkness%20warm%20amber%20lighting%20cinematic%20composition%20mysterious%20aesthetic%20editorial%20photography%20high%20contrast&width=1920&height=1080&seq=hero-slide-1&orientation=landscape",
  },
  {
    id: 2,
    title: "网红黑料",
    subtitle: "独家深扒",
    tagline: "一网打尽",
    description: "直播带货假货产业链大揭秘，头部主播年入过亿内幕",
    link: "/article/zhibo-daihuo-jiahuo-neimu",
    imageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20live%20streaming%20studio%20scene%20in%20darkness%20with%20products%20scattered%20and%20spotlight%20effect%20moody%20atmosphere%20investigative%20journalism%20style%20cinematic%20noir%20aesthetic%20warm%20accent%20lighting%20high%20contrast&width=1920&height=1080&seq=hero-slide-2&orientation=landscape",
  },
  {
    id: 3,
    title: "热点事件",
    subtitle: "深度揭秘",
    tagline: "还原真相",
    description: "知名医美机构医疗事故频发，受害者集体维权事件追踪",
    link: "/article/liangyi-jie-baoguang-yiliao-shigu",
    imageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20dark%20medical%20investigation%20scene%20with%20surgical%20room%20in%20shadow%20moody%20atmosphere%20healthcare%20scandal%20concept%20cinematic%20lighting%20high%20contrast%20editorial%20photography%20with%20warm%20accent&width=1920&height=1080&seq=hero-slide-3&orientation=landscape",
  },
  {
    id: 4,
    title: "明星翻车",
    subtitle: "塌房实录",
    tagline: "持续追踪",
    description: "顶级明星偷税逾亿元，娱乐圈再掀税务风暴",
    link: "/article/dingji-mingxing-shuiwu-weigui",
    imageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20luxury%20lifestyle%20scene%20in%20darkness%20with%20expensive%20items%20scattered%20symbolizing%20downfall%20moody%20atmosphere%20celebrity%20scandal%20concept%20cinematic%20noir%20aesthetic%20high%20contrast%20warm%20golden%20accent&width=1920&height=1080&seq=hero-slide-4&orientation=landscape",
  },
];

export default function HeroCarousel() {
  const [current, setCurrent] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const goTo = useCallback((index: number) => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrent(index);
    setTimeout(() => setIsTransitioning(false), 600);
  }, [isTransitioning]);

  useEffect(() => {
    const timer = setInterval(() => {
      goTo((current + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [current, goTo]);

  const slide = slides[current];

  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <img
        src={slides[0].imageUrl}
        alt={slides[0].description}
        className={`absolute inset-0 w-full h-full object-cover object-top transition-opacity duration-700 ${0 === current ? 'opacity-100' : 'opacity-0'}`}
        title={slides[0].description}
      />
      <img
        src={slides[1].imageUrl}
        alt={slides[1].description}
        className={`absolute inset-0 w-full h-full object-cover object-top transition-opacity duration-700 ${1 === current ? 'opacity-100' : 'opacity-0'}`}
        title={slides[1].description}
      />
      <img
        src={slides[2].imageUrl}
        alt={slides[2].description}
        className={`absolute inset-0 w-full h-full object-cover object-top transition-opacity duration-700 ${2 === current ? 'opacity-100' : 'opacity-0'}`}
        title={slides[2].description}
      />
      <img
        src={slides[3].imageUrl}
        alt={slides[3].description}
        className={`absolute inset-0 w-full h-full object-cover object-top transition-opacity duration-700 ${3 === current ? 'opacity-100' : 'opacity-0'}`}
        title={slides[3].description}
      />

      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>

      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-10 lg:px-20">
          <div className="max-w-3xl">
            <div className="mb-2 flex items-center gap-2">
              <span className="tag-accent text-xs">最新爆料</span>
              <span className="text-background-50/60 text-xs">{slide.tagline}</span>
            </div>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-black font-heading text-background-50 leading-tight mb-2">
              {slide.title}
            </h1>
            <p className="text-xl md:text-2xl font-heading text-primary-400 font-semibold mb-2">{slide.subtitle}</p>
            <p className="text-base md:text-lg text-background-50/70 mb-8 max-w-lg leading-relaxed">
              {slide.description}
            </p>
            <div className="flex items-center gap-4">
              <Link to={slide.link} className="btn-dark text-sm cursor-pointer">
                立即吃瓜 <i className="ri-arrow-right-line ml-1"></i>
              </Link>
              <Link to={`/category/${categories[0].slug}`} className="text-sm text-background-50/80 hover:text-background-50 flex items-center gap-1 transition-colors cursor-pointer">
                浏览更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-0 right-0 flex items-center justify-center gap-2">
        {slides.map((s, idx) => (
          <button
            key={s.id}
            onClick={() => goTo(idx)}
            className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
              idx === current ? 'w-8 bg-primary-500' : 'bg-background-50/30 hover:bg-background-50/50'
            }`}
            aria-label={`第${idx + 1}张`}
          />
        ))}
      </div>

      <button
        onClick={() => goTo((current - 1 + slides.length) % slides.length)}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 rounded-full bg-background-50/10 backdrop-blur-sm border border-background-50/20 flex items-center justify-center text-background-50 hover:bg-background-50/20 transition-all cursor-pointer"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-line text-lg"></i>
      </button>
      <button
        onClick={() => goTo((current + 1) % slides.length)}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 rounded-full bg-background-50/10 backdrop-blur-sm border border-background-50/20 flex items-center justify-center text-background-50 hover:bg-background-50/20 transition-all cursor-pointer"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-line text-lg"></i>
      </button>
    </section>
  );
}